import { faWandMagicSparkles } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '@partful/shared/lib/classNames';
import { Typography } from '@partful/shared/ui/Typography';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { CardMedia, NavCard } from '../Card';
import styles from './NewInstructionCard.module.scss';

export function NewInstructionCard(props: ComponentProps<'a'>) {
  const { t: i18n } = useTranslation();

  return (
    <NavCard
      {...props}
      to="/instructions/create"
      name="instructions_product_library_create_instruction_click"
      aria-label={i18n(`instructions:library.card.new.title`)}
      className={classNames(styles.card)}
    >
      <CardMedia>
        <div className={styles.details}>
          <FontAwesomeIcon icon={faWandMagicSparkles} />
          <Typography appearance="heading4">{i18n(`instructions:library.card.new.title`)}</Typography>
          <Typography>{i18n(`instructions:library.card.new.description`)}</Typography>
        </div>
      </CardMedia>
    </NavCard>
  );
}
